module.exports = "<p>\r\n  selectedanalytics works!\r\n</p>\r\n"